module.exports = "<div class=\"container main-container\">\n\n    <router-outlet></router-outlet>\n    </div>\n    "